import React from 'react';
import { useTranslation } from "react-i18next";
import styled from 'styled-components';
import matan_picture from "../../Assets/Images/matan.png";
import { Link } from 'react-router-dom';

const Container = styled.div`
    max-width: 900px;
    margin: 0 auto;
    padding: 0 2rem;

    @media (max-width: 800px) {
        padding: 0;
    }
`;

const MemberCard = styled.div`
    border-radius: 20px;
    padding: 3rem;
    display: grid;
    grid-template-columns: 300px 1fr;
    gap: 3rem;
    align-items: center;
    position: relative;
    overflow: hidden;

    @media (max-width: 800px) {
        grid-template-columns: 1fr;
        text-align: center;
        padding: 2rem 0;
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${props => props.hoverGradient};
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
        z-index: 1;
    }
        
    @media (max-width: 768px) {
        gap: 2rem;
        padding: 1rem;
    }
`;

const ImageSection = styled.div`
    position: relative;
    z-index: 2;
    
    @media (max-width: 800px) {
        margin: 0 auto;
    }
`;

const MemberImage = styled.img`
    width: 250px;
    height: 250px;
    border-radius: 50%;
    object-fit: cover;
`;

const ContentSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    position: relative;
    z-index: 2;
`;

const Name = styled.h3`
    font-size: 2rem;
    margin: 0;
    color: var(--text-color);
`;

const Role = styled.p`
    font-size: 1.1rem;
    color: var(--text-color);
    opacity: 0.8;
    margin: 0.5rem 0 0;
`;

const Description = styled.p`
    font-size: 1.1rem;
    line-height: 1.6;
    color: var(--text-color);
    opacity: 0.9;
    margin: 0;

    @media (max-width: 800px) {
        max-width: 400px;
    margin: auto;
    }
`;

const StyledLink = styled(Link)`
    display: inline-block;
    padding: 0.8rem 1.5rem;
    background: ${props => props.color};
    color: white;
    text-decoration: none;
    border-radius: 25px;
    font-weight: 500;
    box-shadow: 0 4px 12px ${props => props.shadowcolor};
    transition: all 0.3s ease;
    width: max-content;

    &:hover {
        box-shadow: 0 6px 16px ${props => props.shadowcolor};
    }

    &:active {
        transform: translateY(0);
    }

    @media (max-width: 800px) {
        margin: auto;
    }
`;

const member =
{
    id: 'matan',
    name: 'Matan Dessaur',
    role: 'aboutUs.matanSubtitle',
    image: matan_picture,
    extraText: 'aboutUs.matanExtraText',
    description: 'aboutUs.matanText',
    link: '/toolbox',
    color: 'linear-gradient(135deg, #6376f8 0%, rgba(99, 118, 248, 0.6) 100%)',
    solidColor: '#6376f8',
    shadowcolor: 'rgba(99, 118, 248, 0.3)'
};

export default function MembersGrid() {
    const { t } = useTranslation();
    return (
        <Container>
            <MemberCard
                    key={member.id}
                >
                    <ImageSection>
                        <Link   to={'https://matandessaur.me'}>
                            <MemberImage src={member.image} alt={member.name} />
                        </Link>
                    </ImageSection>

                    <ContentSection>
                        <div>
                            <Name>{member.name}</Name>
                            <Role>{t(member.role)}</Role>
                        </div>
                        <Description>{t(member.description)}</Description>
                        {member.link && (
                            <StyledLink
                                to={member.link}
                                color={member.color}
                                shadowcolor={member.shadowcolor}
                            >
                                {t('aboutUs.clickHere')}
                            </StyledLink>
                        )}
                    </ContentSection>
            </MemberCard>
        </Container>
    );
}